/**
 * Initial calendar selection when (re)planning an existing item: its current planned start —
 * unless it carries no real time. A midnight-UTC timestamp is the "date only, not yet timed"
 * sentinel, and pre-selecting it would pin the draft to 00:00.
 */
export function timedPlannedStartOrNull(
  plannedWorkStartsAt: string | null | undefined,
): string | null {
  if (!plannedWorkStartsAt) return null
  const d = new Date(plannedWorkStartsAt)
  if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0) return null
  return plannedWorkStartsAt
}
